import { distinctUntilChanged, map, merge, Observable } from 'rxjs';
import { action$, ofType } from '@ardoq/rxbeach';
import {
  notifyFiltersChanged,
  setActivePerspective,
  triggerFiltersChangedEvent,
} from './FilterActions';
import { isEqual } from '@ardoq/common-helpers';
import type {
  FieldGlobalAttributes,
  FilterInterfaceFilter,
} from '@ardoq/api-types';
import { filterInterface } from '@ardoq/filter-interface';
import { fieldInterface } from '@ardoq/field-interface';
import { globalFields$ } from 'streams/fields/globalFields$';

export type ReferenceLabelFilterField = {
  referenceLabelFilter: FilterInterfaceFilter;
  labelField: FieldGlobalAttributes | null;
};

const readReferenceLabelFilterField = (): ReferenceLabelFilterField => {
  const referenceLabelFilter = filterInterface.getReferenceLabelFilter();
  const labelField = fieldInterface.getGlobalFieldByName(
    referenceLabelFilter.value
  );
  return { referenceLabelFilter, labelField };
};

export const referenceLabelFilterField$: Observable<ReferenceLabelFilterField> =
  merge(
    action$.pipe(
      ofType(
        setActivePerspective,
        notifyFiltersChanged,
        triggerFiltersChangedEvent
      )
    ),
    globalFields$
  ).pipe(map(readReferenceLabelFilterField), distinctUntilChanged(isEqual));
